// extracted by mini-css-extract-plugin
export default {"validate-container":"page_validate-container__7Nwjf"};